import React from 'react';
import './UpcomingEvents.css';

const UpcomingSportEvents = ({ Image, Title, Type, Description, Id, StartDate, EndDate, Location, OrganizerName, RegistrationClosingDate, routeOnPage }) => {
    return (
        <>
            <div className="col-lg-4 col-md-4 col-sm-12 mr-1 mb-3 topSkills topSkills__contentDisplay" key={Id}
                onClick={routeOnPage}>
                <div className="card-sports">
                    <div className="card-sports-body d-flex flex-column topSkills__content">
                        {Image && Image != null ? <div className="justify-content-center align-items-center">
                            <img src={Image} alt="Store Name" className="img-fluid productTemplate__companyLogo" />
                        </div> : ""}
                        <div className="card-sports-details">
                            <h5 className="card-sports-title">{Title}</h5>
                            {/* <p className="card-sports-title">{Type}</p> */}
                            <p className="card-sports-title">Start From <b>{StartDate?.toDate()?.toDateString()}</b></p>
                            <p className="card-sports-title">Registration Close at <b>{RegistrationClosingDate?.toDate()?.toDateString()}</b></p>
                            {/* <p className="card-sports-title"><b>100 Winners</b></p> */}
                            <p className="card-sports-title">{Location ? Location : ""} <b>{`By ${OrganizerName}`}</b></p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UpcomingSportEvents
